import axios from 'axios';

let redirecting = false;

/**
 * Global axios response interceptor: when the server rejects a request because a staff session
 * is stale (deactivated, group reassigned, or group permissions changed since the token was
 * issued - see StaffAuthFreshnessEvents on the API), clears the client session and redirects to
 * login with a clear message. This is a UX convenience only - the server is what actually enforces
 * the rejection; this interceptor never grants access, it only reacts to an already-rejected request.
 */
export function installAuthFreshnessInterceptor(): void {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      if (status === 401 && !redirecting) {
        redirecting = true;
        const message: string =
          error?.response?.data?.message ?? 'Your session has ended. Please sign in again.';
        sessionStorage.clear();
        sessionStorage.setItem('authNotice', message);
        window.location.href = '/#/login';
      }
      return Promise.reject(error);
    },
  );
}
